import { render } from "./StoreDashboard.vue?vue&type=template&id=572cf31c"
import script from "./StoreDashboard.vue?vue&type=script&lang=js"
export * from "./StoreDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/poshakjojomama-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__